import { useCallback } from 'react';
import { VStack } from '@direct-frontend/components';
import { trackGoal } from '@/entities/trackGoal';
import { Drawer, DrawerBottomFixed, DrawerButton, DrawerHeader } from '@/shared/components/Drawer';
import { Slot } from '@/shared/components/Slot';
import IconPin from './assets/pin.react.svg';
import { type CourierAddressPickerValue } from '../../lib/types/CourierAddressPickerValue';
import styles from './CourierSavedAddressesDialog.module.css';

export interface CourierSavedAddressesDialogProps {
    isOpen: boolean;
    items: CourierAddressPickerValue[];
    onClose: VoidFunction;
    onAddAddress: VoidFunction;
    onChange?: (value: CourierAddressPickerValue) => void;
}

export const CourierSavedAddressesDialog = (props: CourierSavedAddressesDialogProps) => {
    const { items, isOpen, onAddAddress, onClose, onChange } = props;

    const handleChange = useCallback(
        (value: CourierAddressPickerValue) => {
            onChange?.(value);
            trackGoal('address_changed', { address_type: 'saved' });
            onClose();
        },
        [onChange, onClose]
    );

    if (items.length === 0) {
        return null;
    }

    return (
        <Drawer isOpen={isOpen} onClose={onClose}>
            <VStack className={styles.modal}>
                <VStack className={styles.container}>
                    <DrawerHeader title="Адреса доставки" className={styles.title} />
                    <VStack className={styles.list}>
                        {items.map((address, index) => (
                            <div key={address.address} className={styles.item} onClick={() => handleChange(address)}>
                                <Slot
                                    title={address.address}
                                    subtitle={address.locality}
                                    border={index < items.length - 1}
                                    icon={<IconPin />}
                                />
                            </div>
                        ))}
                    </VStack>
                </VStack>
                <DrawerBottomFixed>
                    <DrawerButton onClick={onAddAddress}>Добавить адрес</DrawerButton>
                </DrawerBottomFixed>
            </VStack>
        </Drawer>
    );
};
